<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form
        :model="ruleForm"
        ref="formRef"
        :rules="ruleFormRules"
        label-suffix=":"
        label-width="130px"
      >
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="所属车场" prop="spaceId">
              <el-select disabled v-model="ruleForm.spaceId" style="width:100%" placeholder="请选择所属车场">
                <el-option
                  v-for="item in spaceIdList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="套餐名称" prop="setmealName">
              <el-input
              :disabled="model=='view'"
                v-model="ruleForm.setmealName"
                maxlength="30"
                clearable
                placeholder="请输入套餐名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车辆身份" prop="packageType">
              <el-select :disabled="model=='view'" @change="packageTypeChange" v-model="ruleForm.packageType" style="width:100%" placeholder="请选择车辆身份">
                <el-option
                  v-for="item in packageTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="ruleForm.packageType == 1">
            <el-form-item label="车型大小" prop="carType">
              <el-select :disabled="model=='view'" v-model="ruleForm.carType" style="width:100%" placeholder="请选择车型大小">
                <el-option
                  v-for="item in carTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="ruleForm.packageType == 2">
            <el-form-item label="子母车位" prop="isDouble">
              <el-select :disabled="model=='view'" v-model="ruleForm.isDouble" style="width:100%" placeholder="请选择子母车位">
                <el-option
                  v-for="item in isDoubleData"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="ruleForm.packageType == 2">
            <el-form-item label="计费方式" prop="billingMethod">
              <el-select :disabled="model=='view'" @change="billingMethodChange" v-model="ruleForm.billingMethod" style="width:100%" placeholder="请选择计费方式">
                <el-option
                  v-for="item in billingMethodList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="ruleForm.billingMethod == 2">
            <el-form-item label="收费标准" prop="unitPrice">
              <money-input
              :disabled="model=='view'"
                v-model="ruleForm.unitPrice"
                placeholder="请输入收费标准"
                templateName="元/平"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="收费标准"
              prop="feeInfos"
              v-if="ruleForm.packageType == 1 || ruleForm.billingMethod == 1"
            >
              <el-table border :data="ruleForm.feeInfos" height="300" style="width: 100%">
                <el-table-column align="center" width="80">
                  <template slot="header" slot-scope="scope">
                    <el-button
                      size="mini"
                      type="primary"
                      icon="el-icon-plus"
                      v-if="model!='view'"
                      @click="handleAdd(scope.$index, scope.row)"
                      circle
                    ></el-button>
                  </template>
                  <template slot-scope="scope">
                    <el-button
                    v-if="model!='view'"
                      size="mini"
                      type="danger"
                      icon="el-icon-delete"
                      @click="tableHandleDelete(scope.$index, scope.row)"
                      circle
                    ></el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="feeSort" label="收费科目">
                  <template slot-scope="scope">
                    <el-form
                      :model="scope.row"
                      :ref="'feeInfosRef' + scope.$index"
                      :rules="feeInfosFormRules"
                      label-width="0px"
                    >
                      <el-row :gutter="24">
                        <el-col :span="24">
                          <el-form-item prop="feeSort">
                            <el-select
                            :disabled="model=='view'"
                              v-model="scope.row.feeSort"
                              style="width:100%"
                              placeholder="收费科目"
                            >
                              <el-option
                                v-for="item in monthcarFeeTypeList"
                                :key="item.dictKey"
                                :label="item.dictValue"
                                :value="item.dictKey"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column prop="itemPrice" label="收费金额">
                  <template slot-scope="scope">
                    <el-form
                      :model="scope.row"
                      :ref="'feeInfosRef2' + scope.$index"
                      :rules="feeInfosFormRules"
                      label-width="0px"
                    >
                      <el-row :gutter="24">
                        <el-col :span="24">
                          <el-form-item prop="itemPrice">
                            <money-input
                            :disabled="model=='view'"
                              v-model="scope.row.itemPrice"
                              placeholder="请输入 收费金额"
                              template="append"
                              @blur="moneyInputBlur(scope.row.itemPrice)"
                              style="width: 100%"
                            />
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注信息">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.remark"
                      maxlength="200"
                      :disabled="model=='view'"
                      clearable
                      placeholder="请输入 备注信息"
                    ></el-input>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="ruleForm.billingMethod != 2">
            <el-form-item label="收费金额" prop="costPrice">
              <money-input
                disabled
                v-model="ruleForm.costPrice"
                placeholder="请输入 维修金额"
                template="append"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="过期临停收费标准" prop="expiredTempCarFeeRuleId" v-if="ruleForm.packageType == 1">
              <el-select :disabled="model=='view'" v-model="ruleForm.expiredTempCarFeeRuleId" style="width:100%" clearable>
                <el-option
                  v-for="item in tempFeeRuleList"
                  :key="item.id"
                  :label="item.ruleName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="跨区临停收费标准" prop="crossTempCarFeeRuleId" v-if="ruleForm.packageType == 1">
              <el-select :disabled="model=='view'" v-model="ruleForm.crossTempCarFeeRuleId" style="width:100%" clearable>
                <el-option
                  v-for="item in tempFeeRuleList"
                  :key="item.id"
                  :label="item.ruleName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="    text-align: right;" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
        取消
      </el-button>
    </div>
  </div>
</template>
<script>
import { getDictionary } from '@/api/common.js';
import { getParkList ,carfeeruleAdd,carfeeruleDetail,carfeeruleUpdate} from './carMaster/index.js';
import { getList } from '@/api/v4ward/park/tempcarv2/cartempcarfeerule';
export default {
  components: {},
  props: {
    row: {
      default: {},
    },
    spaceId: {},
    model: {},
  },
  data() {
    var validateFeeInfos1 = (rule, value, callback) => {
      if(value.length==0){
        callback(new Error('请新增收费标准！'));
          return;
      }
      callback();
    };
    return {
      ruleFormRules: {
        spaceId: [{ required: true, message: '请选择所属车场 ', trigger: 'change' }],
        setmealName: [{ required: true, message: '请输入套餐名称', trigger: 'blur' }],
        packageType: [{ required: true, message: '请选择套餐类型', trigger: 'change' }],
        carType: [{ required: true, message: '请选择车型大小', trigger: 'change' }],
        isDouble: [{ required: true, message: '请选择子母车位', trigger: 'change' }],
        billingMethod:[{ required: true, message: '请选择子计费方式', trigger: 'change' }],
        unitPrice:[{ required: true, message: '请输入收费标准', trigger: 'change' }],
        feeInfos:[{required: true, validator: validateFeeInfos1, trigger: 'change' }]
      },
      feeInfosFormRules:{
        itemPrice:[{ required: true, message: '请输入收费金额', trigger: 'blur' }],
        feeSort:[{ required: true, message: '请选择收费科目', trigger: 'change' }],
      },
      carTypeList:[],
      packageTypeList:[],//套餐类型
      //临停收费标准
      tempFeeRuleList:[],
      billingMethodList:[],//计费方式
      spaceStatusData: [
        {
          dictKey: '1',
          dictValue: '已出售',
        },
        {
          dictKey: '2',
          dictValue: '空闲',
        },
      ],
      isDoubleData: [
        {
          dictKey: '0',
          dictValue: '否',
        },
        {
          dictKey: '1',
          dictValue: '是',
        },
      ],

      ruleForm:{
        setmealName:'',
        spaceId:'',
        packageType:'',
        expiredTempCarFeeRuleId:'',
        crossTempCarFeeRuleId:'',
        carType:'',
        isDouble:'',
        billingMethod:'',
        unitPrice:'',
        feeSort:"",
        feeInfos:[],
        costPrice:''
      },
      spaceIdList: [],
      monthcarFeeTypeList:[]
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    packageTypeChange(){
     this.ruleForm. costPrice=''
     this.ruleForm.isDouble=''
     this.ruleForm.feeInfos=[]
     this.ruleForm.billingMethod =""
     this.ruleForm.unitPrice =''
    },
    billingMethodChange(){
      this.ruleForm.feeInfos=[]
      this.ruleForm. costPrice=''
    },
    moneyInputBlur(value){
      console.log("aaa",value)
      if(value!=""){
        let money =0
        this.ruleForm.feeInfos.forEach(item=>{
          money+=Number(item.itemPrice)
        })
        this.ruleForm.costPrice = money
      }
    },
    tableHandleDelete(index, row) {
            this.ruleForm.feeInfos.splice(index, 1);
            let money =0
            this.ruleForm.feeInfos.forEach(item=>{
          money+=Number(item.itemPrice)
        })
        this.ruleForm.costPrice = money
    },
    handleAdd() {
      this.ruleForm.feeInfos.push({
        feeSort:'',
        itemPrice:'',
        remark:''
      });
    },
    initData() {
      if(this.model=="add"){
this.ruleForm.spaceId=this.row.spaceId

      }else{
        carfeeruleDetail({id:this.row.id}).then((res) => {
          this.ruleForm = res.data;
          this.ruleForm.packageType +=""
          this.ruleForm.carType +=""
          this.ruleForm.isDouble +=""
          this.ruleForm.billingMethod +=""
          if(this.ruleForm.carType =="null"){
            this.ruleForm.carType = ""
          }
          if(this.ruleForm.isDouble =="null"){
            this.ruleForm.isDouble = ""
          }
          if(this.ruleForm.billingMethod =="null"){
            this.ruleForm.billingMethod = ""
          }
          if(this.ruleForm.costPrice ==null){
            this.ruleForm.costPrice = ""
          }
          if(this.ruleForm.appFlag ==null){
            this.ruleForm.appFlag = ""
          }
        })
      }
      getParkList().then((res) => {
        this.spaceIdList = res.data;
      });
      getDictionary("package_type").then(res=>{
        this.packageTypeList = res.data
      })
      getDictionary("billing_method").then(res=>{
        this.billingMethodList = res.data
      })
      getDictionary("car_type_v2").then(res=>{
        this.carTypeList = res.data
      })
      getDictionary("monthcar_fee_type").then(res=>{
        this.monthcarFeeTypeList = res.data
        this.monthcarFeeTypeList.forEach(item=>{
          item.dictKey = parseInt(item.dictKey)
        })
        console.log(this.monthcarFeeTypeList)
      })
      //临停收费标准
      getList({parkingLotId: this.row.spaceId}).then((res) => {
        this.tempFeeRuleList = res.data.records;
      });
    },
    saveRecord(){
     console.log( this.ruleForm.feeInfos)
      let feeInfosListValide = true;
      let feeInfosListValide2 = true;
      this.ruleForm.feeInfos.forEach((item, index) => {
        console.log(index);
        let str = 'feeInfosRef' + index;
        console.log(str);
        this.$refs[str].validate((valid) => {
          if (valid) {
          } else {
            feeInfosListValide = false;
          }
        });
        let str2 = "feeInfosRef2" + index;
        this.$refs[str2].validate((valid) => {
          if (valid) {
          } else {
            feeInfosListValide2 = false;
          }
        });
      });
      this.$refs['formRef'].validate((valid) => {
          if (valid) {
            if(feeInfosListValide&&feeInfosListValide2){
              if(this.model=='add'){
                carfeeruleAdd(this.ruleForm).then(res=>{
                  this.$message.success("新增成功");
                  this.$emit('success');
                 })
              }else{
                carfeeruleUpdate(this.ruleForm).then(res=>{
                  this.$message.success("修改成功");
                  this.$emit('success');
                })
              }
            }
          } else {
          }
        });
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
::v-deep .el-col-12 {
  height: 54px;
}
</style>
